import request from '@/utils/request2';
export function structureList(data) {
  return request.post('admin/company-structure/list', data);
}
export function structureDetail(data) {
  return request.post('admin/company-structure/detail', data);
}
export function addStructure(data) {
  return request.post('admin/company-structure/store', data);
}
export function editStructure(data) {
  return request.post('admin/company-structure/edit', data);
}
export function delStructure(data) {
  return request.post('admin/company-structure/delete', data);
}
export function structureStatus(data) {
  return request.post('admin/company-structure/status', data);
}
export function structureWorkersList(data) {
  return request.post('admin/company-structure/workers', data);
}
export function structureBranch(data) {
  return request.post('admin/company-structure/branch', data);
}
export function structureResource(data) {
  return request.post('admin/company-structure/resource', data);
}